const info = {
    title: `Refill Your Prescription`,
    subtitle: `Get Your Medication Quickly & Easily`,
}

export default info

